<template>
  <div class="exchange_list">
    <div class="deco">
      <h2 class="access_hidden">포인트 전환 상세 내역 (글로벌)</h2>
      <period-setting :cateArr="cateArr"></period-setting>
      <div v-if="exchangeList.list && exchangeList.list.length" class="list global_list">
        <table class="global_exchange_list_table">
          <col class="global_contents" />
          <col class="global_state" />
          <col class="global_contents" />
          <col class="global_state" />
          <col class="global_state" />
          <col class="global_state" />
          <thead>
            <tr class="global_table_header_row">
              <th class="global_contents">{{ $t('exchangeHistory.global.table.column.regiDate') }}</th>
              <th class="global_state">{{ $t('exchangeHistory.global.table.column.type') }}</th>
              <th class="global_state_order">{{ $t('exchangeHistory.global.table.column.orderNo') }}</th>
              <th class="global_state" v-html="$t('exchangeHistory.global.table.column.withdrawPoint')"></th>
              <th class="global_state" v-html="$t('exchangeHistory.global.table.column.withdrawAmount')"></th>
              <th class="global_state">{{ $t('exchangeHistory.global.table.column.status') }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="windowWidth >= 1280">
              <tr class="global_table_row" v-for="(el, idx) in exchangeList.list" :key="idx">
                <td class="global_contents">
                  <span v-if="el.regDate" class="global_date">{{ formattedDates(el.regDate)[0] }}</span>
                  <span v-if="el.regDate" class="global_time">{{ formattedDates(el.regDate)[1] }}</span>
                </td>
                <td class="global_type">{{ withdrawalType(el.withdrawalType) }}</td>
                <td class="global_state_order">
                  {{ el.orderId }}
                </td>
                <td class="global_point">
                  <span>
                    {{ addComma(el.amount) }}
                  </span>
                </td>
                <td class="global_point">
                  <span> {{ currencyAmount(el.withdrawalType, el.refCurrency, el.currencyAmount) }} </span>
                </td>
                <td class="global_status">
                  <span :class="stateClass(el.status)">
                    {{ getExchangeStatus(el.status) }}
                  </span>
                </td>
              </tr>
            </template>
            <template v-if="windowWidth >= 768 && windowWidth < 1280">
              <tr v-for="(el, idx) in exchangeList.list" :key="idx">
                <td class="contents">
                  <span v-if="el.regDate" class="global_date">{{ el.regDate }}</span>
                  <div class="global_point">
                    {{ addComma(el.amount) }}
                  </div>
                  <span class="global_state_order">
                    {{ $t('exchangeHistory.global.table.column.orderNo') }}: {{ el.orderId }}
                  </span>
                </td>
                <td class="global_state">
                  <span class="global_point">
                    {{ currencyAmount(el.withdrawalType, el.refCurrency, el.currencyAmount) }}
                  </span>
                  <span class="global_point global_type">{{ withdrawalType(el.withdrawalType) }}</span>
                  <span class="global_status" :class="stateClass(el.status)">
                    {{ getExchangeStatus(el.status) }}
                  </span>
                </td>
              </tr>
            </template>
            <template v-if="windowWidth >= 480 && windowWidth < 768">
              <tr v-for="(el, idx) in exchangeList.list" :key="idx">
                <td class="contents">
                  <span v-if="el.regDate" class="global_date">{{ el.regDate }}</span>
                  <div class="global_point">
                    {{ addComma(el.amount) }}
                  </div>
                  <span class="global_state_order">
                    {{ $t('exchangeHistory.global.table.column.orderNo') }}: {{ el.orderId }}
                  </span>
                </td>
                <td class="state">
                  <span class="global_point">
                    {{ currencyAmount(el.withdrawalType, el.refCurrency, el.currencyAmount) }}
                  </span>
                  <span class="global_point global_type">{{ withdrawalType(el.withdrawalType) }}</span>
                  <span class="global_status" :class="stateClass(el.status)">
                    {{ getExchangeStatus(el.status) }}
                  </span>
                </td>
              </tr>
            </template>
            <template v-if="windowWidth < 480">
              <tr v-for="(el, idx) in exchangeList.list" :key="idx">
                <div class="contents">
                  <span v-if="el.regDate" class="global_date">{{ el.regDate }}</span>
                  <div class="global_point">
                    {{ addComma(el.amount) }}
                  </div>
                  <span class="global_state_order">
                    {{ $t('exchangeHistory.global.table.column.orderNo') }}: {{ el.orderId }}
                  </span>
                </div>
                <div class="state">
                  <div>
                    <span class="global_point">
                      {{ currencyAmount(el.withdrawalType, el.refCurrency, el.currencyAmount) }}
                    </span>
                    <span class="global_point global_type">{{ withdrawalType(el.withdrawalType) }}</span>
                  </div>
                  <span class="global_status" :class="stateClass(el.status)">
                    {{ getExchangeStatus(el.status) }}
                  </span>
                </div>
              </tr>
            </template>
          </tbody>
        </table>
        <pagination
          @custom-change="changeOffset"
          :offset="exchangeList.pageNo"
          :total-item-cnt="exchangeList.totalCount"
          :list-item-size="10"
          :page-size="exchangeList.pageSize"
        >
        </pagination>
        <v-button
          v-if="windowWidth >= 768"
          class="global_detail_button btn06"
          :text="$t('global.detailButton')"
          @handleClick="handleClickDetail"
        />
      </div>
      <p v-else class="none"><v-icon clsName="icon_none" /><span v-html="errorMessage"></span></p>
    </div>
    <div>
      <h3 class="attention_title">{{ $t('exchangeHistory.caution.global.title') }}</h3>
      <ul class="attention" v-html="$t('exchangeHistory.caution.global.content')" />
      <ul
        v-if="pointInfo.njPointEnable"
        class="attention"
        v-html="$t('exchangeHistory.caution.global.contentNexonPoint')"
      />
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin';
import { mapActions, mapGetters } from 'vuex';
import PeriodSetting from '@/components/modules/exchangeHistory/PeriodSetting';
import Pagination from '@/components/modules/common/Pagination';
import VIcon from '@/components/atoms/VIcon';
import VButton from '@/components/atoms/VButton';
import { exchangeHistoryErrorMsg } from '@/utils/errorMsg';
import sendLog from '@/utils/analistic';
import eventBus from '@/utils/eventBus';
import { isMobile } from '@/utils';
import { exchangeApi } from '@/api';
import {
  GLOBAL_EXCHANGE_STATUS_CLASS,
  GLOBAL_EXCHANGE_STATUS_TO_SHOW,
  GLOBAL_WITHDRAW_REQUEST_STATUS_BY_EXCHANGE_STATUS,
} from '@/consts/consts';
import { GLOBAL_WITHDRAW_TYPE } from '@/consts/consts';

export default {
  mixins: [mixin],
  components: {
    PeriodSetting,
    Pagination,
    VIcon,
    VButton,
  },
  data() {
    return {
      errorMessage: '',
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters(['serviceUrl']),
    ...mapGetters('point', ['pointInfo']),
    ...mapGetters('exchange', [
      'exchangeList',
      'exchangeListPageSize',
      'exchangeListPageNo',
      'exchangeListStartDate',
      'exchangeListEndDate',
      'exchangeListStatus',
    ]),
    cateArr() {
      return this.$i18n.t('exchangeHistory.globalStatusList');
    },
    withdrawalType() {
      return (type) => {
        return this.$t(`global.${GLOBAL_WITHDRAW_TYPE[type]}`);
      };
    },
    currencyAmount() {
      return (type, currency, amount) => {
        return GLOBAL_WITHDRAW_TYPE[type] === 'nexonPoint' ? `${amount} ${currency}` : `${currency} ${amount}`;
      };
    },
    formattedDates() {
      return (inputDate) => {
        const regex = /(\d{4}\.\d{2}\.\d{2}\s\d{2}:\d{2}:\d{2})\s\(\w{3}\s([\+|\-]\d{1,2})\)/;
        const match = inputDate.match(regex);

        if (match) {
          const formattedDate = match[1];
          const timeZone = match[2];

          return [formattedDate, `(UTC${timeZone})`];
        } else {
          return [];
        }
      };
    },
    getExchangeStatus() {
      return (status) => {
        return this.$t(`exchangeHistory.globalStatusRow.${GLOBAL_EXCHANGE_STATUS_TO_SHOW[status]}`);
      };
    },
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.init();
      }
    },
  },
  created() {
    this.init();
  },
  mounted() {
    eventBus.$on('listUpdate', this.listUpdate);
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy() {
    eventBus.$off('listUpdate', this.listUpdate);
    window.removeEventListener('resize', this.handleWindowResize);
  },
  methods: {
    ...mapActions('exchange', [
      'getBankList',
      'getGlobalExchangeHistory',
      'setExchangeListPageNo',
      'setExchangeListStartDate',
      'setExchangeListEndDate',
      'setExchangeDetail',
    ]),
    async init() {
      await this.listUpdate();
    },
    historyParameter() {
      const pointStatus = GLOBAL_WITHDRAW_REQUEST_STATUS_BY_EXCHANGE_STATUS[this.exchangeListStatus || 0];

      return {
        startDate: this.exchangeListStartDate,
        endDate: this.exchangeListEndDate,
        pointStatus,
        pageNo: this.exchangeListPageNo,
        pageSize: this.exchangeListPageSize,
      };
    },
    async changeOffset(offset) {
      this.setExchangeListPageNo(offset);
      const apiReturn = await this.getGlobalExchangeHistory(this.historyParameter());
      this.errorMessage = exchangeHistoryErrorMsg(apiReturn);
    },
    stateClass(val) {
      return GLOBAL_EXCHANGE_STATUS_CLASS.PLUS.includes(val)
        ? 'plus'
        : GLOBAL_EXCHANGE_STATUS_CLASS.MINUS.includes(val)
        ? 'minus'
        : '';
    },
    handleClick(val) {
      // window.scrollBy(0, 1);
      this.setExchangeDetail(val);
    },
    handleA2S(e) {
      sendLog(e.target.attributes.obj.value, JSON.parse(e.target.attributes.opt.value));
    },
    async listUpdate() {
      this.setExchangeListEndDate(this.$moment().format('YYYY-MM-DD'));
      this.setExchangeListStartDate(this.$moment().add(-1, 'months').add(1, 'days').format('YYYY-MM-DD'));

      const apiReturn = await this.getGlobalExchangeHistory(this.historyParameter());
      this.errorMessage = exchangeHistoryErrorMsg(apiReturn);
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    async handleClickDetail() {
      const response = await exchangeApi.getGlobalExchangeHistoryDetail({ uiCulture: this.$i18n.locale });

      const features = !isMobile ? 'width=1280, height=1024' : '';
      window.open(response.data.data.iframeURL, '_blank', features);
    },
  },
};
</script>
<style scoped>
.global_point {
  top: 50%;
  left: 30px;
  width: 140px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #333333;
}
.global_type {
  text-align: center;
  font-family: 'Noto Sans JP', 'Malgun Gothic';
  font-size: 14px;
  font-weight: 700;
  color: #3d4148;
}
.global_time {
  display: block;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #999999;
}
.global_date {
  display: block;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
}
.global_contents {
  width: 229px;
  line-height: 50px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  vertical-align: middle;
}
.global_state {
  vertical-align: middle;
  position: relative;
  line-height: 30px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  width: 130px;
  text-align: center;
  word-break: break-word;
}
.global_state_order {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 50px;
  text-align: center;
  vertical-align: middle;
}
.global_table_header_row {
  height: 50px;
  border-top: 1px #333 solid;
}
.global_list {
  position: relative;
}
.global_detail_button {
  width: 120px;
  bottom: 0px;
  right: 0px;
  margin-right: 30px;
  /* height: 100px; */
  /* background-color: red; */
  position: absolute;
}
.global_status {
  /* display: inline-block; */
  width: 160px;
  font-size: 14px;
  text-align: center;
  color: #999;
}
.exchange_list {
  word-break: keep-all;
}
@media all and (max-width: 1280px) {
  tbody {
    border-bottom: 1px solid #ddd;
  }
  .global_state {
    /* display: flex; */
    padding-right: 30px;
    white-space: nowrap;
    align-items: center;
    vertical-align: middle;
  }
  .contents {
    width: 100%;
  }
  .global_table_header_row {
    display: none;
  }
  .global_state .global_point {
    margin-right: 30px;
  }
  .global_point {
    margin-top: 14px;
    text-align: left;
    font-weight: 700;
    font-size: 18px;
  }
  .global_type {
    font-size: 13px;
  }
  .global_date {
    color: #999;
  }
  .global_state_order {
    display: block;
    margin-top: 10px;
    line-height: 13px;
    color: #8c8c8c;
    text-align: left;
  }
  .global_point_contents {
    display: flex;
    flex-direction: row;
  }
}

@media all and (max-width: 767px) {
  .state {
    padding: 28px 0 27px 0px;
    vertical-align: middle !important;
  }
  .global_status {
    white-space: nowrap;
    display: block;
    width: 100%;
    margin-top: 10px;
    text-align: right;
  }
  .global_point {
    white-space: nowrap;
    line-height: 18px;
  }
  .global_type {
    margin-left: 8px;
    padding: 8px 0 10px 8px;
    /* line-height: 24px; */
  }
  .contents {
    padding: 28px 0 27px 0px !important;
  }
}

@media all and (max-width: 480px) {
  tr {
    border-bottom: 1px solid #ddd;
  }
  .exchange_list {
    .state {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap; /* 줄바꿈 방지 */
      align-items: center;
      padding-top: 0;
    }
  }
  .global_contents {
    width: 100%;
  }
  .global_state {
    width: 0;
  }
  .global_status {
    display: inline;
    margin-top: 0;
    display: inline-block; /* width 적용 가능하게 변경 */
    white-space: nowrap; /* 줄바꿈 방지 */
    width: auto; /* 기존 width 제거 */
    min-width: 160px;
  }
}
</style>
